import {
  getIndicatorDataApi,
  getSaveComponentDataApi,
} from './fetch'
import { handleOneIndictorToMoreLine } from './funcs'
export default {
  props: {
    config: {
      type: Object,
    },
    componentType: {
      type: String,
    },
    globalConfig: {
      type: Object,
    },
    filterParams: {
      type: Object,
    },
    componentStatus: {
      type: String,
      default: 'edit',
    },
  },
  data () {
    return {
      option: {},
      charts: null,
      timer: null,
      index: -1,
      borderImgUrl: '',
      loading: false,
      indicatorDescription: '数据说明',
      emptyData: false,
      currentRequestId: 0, // 用于追踪请求的ID
    }
  },
  computed: {
    dataSource () {
      return this.config.chartSet.dataSource
    },

    borderStyle () {
      return this.config.chartSet.borderStyle.borderTemplate
    },
    // 数据指标
    selectedIndicatorIdList () {
      return this.config.chartViewData.selectedIndicatorList?.map(bar => bar?.dataIndicator)?.filter(foo => foo)
    },

  },
  beforeDestroy () {
    clearInterval(this.timer)
    if (this.charts) {
      this.charts.dispose()
    }
  },
  watch: {
    // // 监听数据源
    dataSource: {
      handler: function (newValue, oldValue) {
        if (newValue === oldValue) return
        if (newValue && !oldValue) {
          this.config.chartViewData.chartData = this.config.chartViewData.chartData ?? this.config.chartViewData.initData
          return
        }
        this.config.chartViewData.chartData = this.config.chartViewData.initData
        if (newValue !== 'indicatorLib') {
          this.config.chartViewData.selectedIndicatorList = []
        }
      },
      deep: true,
      immediate: true,
    },
    //  设置指标时
    selectedIndicatorIdList: {
      handler: async function (newValue = [], oldValue = []) {
        // 指标总共有 单指标、单指标多数据、多指标 这几种情况
        try {
          // 没有指标
          if (!newValue?.length) return
          // 增加请求ID
          const requestId = ++this.currentRequestId

          // 删除一项指标，删除该指标对应数据
          if (newValue?.length < oldValue?.length) {
            const delIdIndex = oldValue.indexOf(oldValue.find(bar => !newValue.includes(bar)))
            this.delIndictorDataByIdx(delIdIndex)
            //  保存组件数据
            this.saveChartData(newValue)
            return
          }
          // 修改指标，找出修改的那个指标id
          const changeIndexId = newValue?.find(bar => !oldValue?.includes(bar))
          if (!changeIndexId) return
          if (newValue?.length > 1) {
            // 请求数据详情
            const { dataList } = await getIndicatorDataApi(changeIndexId, this.filterParams)
            // 检查请求ID是否是最新的,如果不是，获取的数据丢弃
            if (requestId !== this.currentRequestId) return
            // 找出被修改指标的下标
            const indictorIndex = newValue.indexOf(changeIndexId)
            // 后端返回空数据
            if (!dataList.length) {
              if (indictorIndex === 0) {
                this.setEmptyData()
              }
              return
            }
            // 改的是第一个指标
            if (indictorIndex === 0) {
              // 重新获取所有数据
              const title = await this.getChartData(this.filterParams)
              this.config.chartTitle = !this.config.chartTitle && title && this.componentStatus === 'edit' ? title : this.config.chartTitle
            } else {
              // 改的是第N个指标
              // 多指标不会有label，将有label的数据过滤
              if (!dataList[0].label) {
                this.setIndictorDataByIndex(dataList, indictorIndex)
              }
            }
          } else {
            // 单指标分为，单指标多条数据、单指标单条数据
            const { dataList, indicatorName } = await getIndicatorDataApi(newValue[0], this.filterParams, requestId)
            // 检查请求ID是否是最新的,如果不是，获取的数据丢弃
            if (requestId !== this.currentRequestId) return
            // 设置组件标题
            this.config.chartTitle = !this.config.chartTitle && indicatorName && this.componentStatus === 'edit' ? indicatorName : this.config.chartTitle
            // 后端返回空数据
            if (!dataList?.length) {
              this.setEmptyData()
              return
            }
            // 处理数据
            this.handleSingleIndictorData(dataList)
          }
          // 设置指标说明
          this.setIndexDescText()
          //  保存组件数据
          this.saveChartData(newValue)
        } catch (e) {
          this.$error(e)
        }
      },
      deep: true,
      immediate: true,
    },

  },
  methods: {
    // 鼠标移入移出
    mouseEvents () {
      // 鼠标划入
      this.charts.on('mouseover', () => {
        // 停止定时器，清除之前的高亮
        clearInterval(this.timer)
        this.timer = ''
        this.charts.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: this.index,
        })
      })
      // 鼠标划出重新定时器开始
      this.charts.on('mouseout', () => {
        this.tooltipsActive()
      })
    },

    /**
 * 提示轮播
 * @param {*} dataLength  一次轮播 需要数据高亮的次数
 */
    tooltipsActive () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      const componentType = this.config.chartComponentType
      // 获取 echarts 组件上 tooltip 需要循环的数据长度
      let dataLength = null
      if (['LineChart', 'BarChart'].includes(componentType)) {
        dataLength = this.series[0].data.length
      } else if (['PieChart', 'MapChart'].includes(componentType)) {
        dataLength = this.renderData.length
      } else if (['Rank'].includes(componentType)) {
        dataLength = this.series.data.length
      }
      // 用定时器控制高亮
      this.timer = setInterval(() => {
        // 清除之前的高亮
        this.charts.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: this.index,
        })
        if (this.index === dataLength - 1) {
          this.index = 0
        } else {
          this.index++
        }

        // 当前下标高亮
        this.charts.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: this.index,
        })

        this.charts.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.index,
        })
      }, this.config.chartSet.chartStyle.carouselDelay * 1000)
    },
    //  保存组件数据指标
    async saveChartData (selectedIndicatorIdList) {
      await getSaveComponentDataApi({
        chartData: JSON.stringify({
          selectedIndicatorList: selectedIndicatorIdList?.map(item => { return { dataIndicator: item } }) ?? [],
          showIndicator: this.config.chartViewData.showIndicator,
          detailIndicator: this.config.chartViewData.detailIndicator,
        }),
        initData: JSON.stringify(this.config.chartViewData.initData),
        chartDataType: 2,
        chartViewId: this.config.chartViewData.chartViewId,
        id: this.config.chartViewData?.id || null,
        initDataFlag: 0,
      })
    },
    /**
     *  获取/更新所有指标的数据
     *  返回值是第一个指标的标题，用于编辑时修改第一个指标时，设置组件标题用
     */
    async getChartData (filterParams) {
      try {
        this.loading = true
        // 首条指标的 title
        let firstIndexTitle = ''
        if (this.selectedIndicatorIdList?.length > 0) {
          const requestId = ++this.currentRequestId // 增加请求ID

          // 各组件数据回填  需要判断 多指标的情况
          const promiseList = this.selectedIndicatorIdList?.map(indexId => {
            return getIndicatorDataApi(indexId, filterParams, requestId)
          })
          // 获取指标数据
          const resData = await Promise.all(promiseList)
          // 检查请求ID是否是最新的,如果不是，获取的数据丢弃
          if (requestId !== this.currentRequestId) return
          this.indicatorDescription = '数据说明'

          resData.forEach((resItem, index) => {
            // 没有数据时 填充空数据
            if (resItem?.dataList?.length === 0) {
              if (index === 0) {
                this.setEmptyData()
              }
              return
            }
            // 获取首条数据时
            if (index === 0) {
              this.handleSingleIndictorData(resItem?.dataList)
              // 设置组件标题
              firstIndexTitle = resItem?.indicatorName
            } else {
            // 多指标时
              if (!resItem.dataList[0].label) {
              // 将后续的指标数据一条一条添加到chartViewData
                this.setIndictorDataByIndex(resItem.dataList, index)
              }
            }
            // 设置指标说明
            this.indicatorDescription += `<br/>${resItem.indicatorName}: ${resItem.indicatorDescription} `
          })
        }
        return firstIndexTitle
      } catch (e) {
        this.$error(e)
      } finally {
        this.loading = false
      }
    },
    // 设置指标的第一条数据
    handleSingleIndictorData (resData) {
      if (this.config.chartComponent === 'scrollTable') {
        this.config.chartViewData.chartData = resData
        return
      }
      // 通过是否有label来判断是否是多指标，但地图数据也需要判断label
      if (resData[0].label) {
        if (this.config.chartComponent === 'mapChart') {
          // >>>>>> 地图数据需要展示所属大区，特殊处理 <<<<<<<<<<<<
          this.config.chartViewData.chartData = resData.map(bar => {
            return {
              x: bar.x,
              y_0: bar.y,
              label: bar.label,
            }
          })
        } else {
          //  >>>>>>>> 单指标多条数据 <<<<<<<<<
          this.config.chartViewData.chartData = handleOneIndictorToMoreLine(resData)
        }
      } else {
        // >>>>>>>> 单指标 单数据 <<<<<<<<<
        this.config.chartViewData.chartData = resData.map(bar => {
          return {
            x: bar.x,
            y_0: bar?.y || 0,
          }
        })
      }
    },
    // 通过指标下标来设置指标数据
    setIndictorDataByIndex (resData, indictorIndex) {
      this.config.chartViewData.chartData = this.config.chartViewData.chartData.map((item, index) => {
        const curItem = resData.find(bar => bar.x === item.x)
        if (curItem) {
          item[`y_${indictorIndex}`] = curItem.y
        } else {
          // 若x轴数据不匹配  首行不匹配则填充对应指标的y值，其余数据不匹配补0
          item[`y_${indictorIndex}`] = index === 0 ? resData[0].y : 0
        }
        return item
      })
    },
    // 指标说明文案拼接
    setIndexDescText () {
      this.indicatorDescription = '数据说明'
      this.selectedIndicatorIdList.forEach(bar => {
        const res = this.config.dataIndicatorList?.find(indicator => {
          return indicator.value === bar
        })
        this.indicatorDescription += `<br/>${res?.label}: ${res?.indicatorDescription} `
      })
    },
    // 通过指标的下标来删除指标对应的数据
    delIndictorDataByIdx (delIdx) {
      let maxI = 0
      Object.keys(this.config.chartViewData.chartData).forEach(key => {
        const i = key.split('_')[1]
        maxI = maxI > i ? maxI : i
      })
      this.config.chartViewData.chartData = this.config.chartViewData.chartData
        .map((item, index) => {
          if (maxI === delIdx) {
            // 删除最后一条指标
            delete item[`y_${delIdx}`]
          } else {
            // 删除其中一条指标
            Object.keys(item).forEach((key, idx) => {
              item[`y_${delIdx + idx}`] = item[`y_${delIdx + idx + 1}`]
            })
            delete item[`y_${maxI}`]
          }
          return item
        })
    },
    //  设置空数据
    setEmptyData () {
      this.config.chartViewData.chartData = []
    },
  },
}
